import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  BROWSE,
  IN_REALIZATION,
  navigationMapping,
} from '../../consts/navigation';
import { TOGGLE_MENU } from '../../redux/Layout';
import { SIGN_OUT } from '../../redux/UserData';
import UiCounter from '../Ui/Counter/Counter';
import './Menu.scss';
import { compose } from 'redux';
import withScopedTranslations from '../../withScopedTranslations/withScopedTranslations';

class Menu extends Component {
  componentDidMount() {
    document.querySelector('.menu-area').addEventListener('click', this.handleMenuItemClick);
  }

  componentWillUnmount() {
    document.querySelector('.menu-area').removeEventListener('click', this.handleMenuItemClick);
  }

  handleMenuItemClick = (event) => {
    event.preventDefault();

    if (event.target.closest('a').getAttribute('href') === '#sign_out') {
      this.props.signOut();
    }

    if (event.target && event.target.closest('a')) {
      this.props.toggleMenu();
    }

    const href = event.target.closest('a').getAttribute('href');
    this.props.history.push(href);
  }

  render() {
    const { newConversationsCount, dealerId, t } = this.props;
    return (
      <div className="col-md-2 left-column menu-area">
        <ul>
          <NavLink to={navigationMapping[BROWSE].table_url} className="menu-area__link">
            <div className="menu-area__link__element menu__browse">
              <i className="material-icons menu-area__icon">motorcycle</i>
              <span>{t('browse')}</span>
            </div>
          </NavLink>
          <NavLink to="/dashboard/bets" className="menu-area__link">
            <div className="menu-area__link__element menu__bets">
              <i className="material-icons menu-area__icon">gavel</i>
              <span>{t('bets')}</span>
            </div>
          </NavLink>
          <NavLink to="/dashboard/buy-now" className="menu-area__link">
            <div className="menu-area__link__element menu__bets">
              <i className="material-icons menu-area__icon">sell</i>
              <span>{t('buy_now')}</span>
            </div>
          </NavLink>
          <NavLink to={navigationMapping[IN_REALIZATION].table_url} className="menu-area__link">
            <div className="menu-area__link__element menu__in-realization">
              <i className="material-icons menu-area__icon">local_shipping</i>
              {t('in_realization')}
            </div>
          </NavLink>
          <NavLink to="/dashboard/archive" className="menu-area__link">
            <div className="menu-area__link__element menu__archive">
              <i className="material-icons menu-area__icon">assignment_turned_in</i>
              {t('archive')}
            </div>
          </NavLink>
          {dealerId === 6 &&
            <NavLink to="/dashboard/ads" className="menu-area__link">
              <div className="menu-area__link__element menu__archive">
                <i className="material-icons menu-area__icon">insert_chart</i>
                {t('ads')}
              </div>
            </NavLink>
          }
          <NavLink to="/dashboard/invoices" className="menu-area__link">
            <div className="menu-area__link__element menu__fv">
              <i className="material-icons menu-area__icon">euro_symbol</i>
              {t('fv')}
            </div>
          </NavLink>
          <NavLink to="/dashboard/conversations" className="menu-area__link">
            <div className="menu-area__link__element">
              <i className="material-icons menu-area__icon">message</i>
              <span className="menu-element__conversations">{t('conversations')}</span>
              { newConversationsCount > 0 && <UiCounter count={newConversationsCount} /> }
            </div>
          </NavLink>
          <NavLink to="/dashboard/settings" className="menu-area__link">
            <div className="menu-area__link__element menu__settings">
              <i className="material-icons menu-area__icon">settings</i>
              <span>{t('settings')}</span>
            </div>
          </NavLink>
          <a href="#sign_out" className="menu-area__link menu-area__link--logout">
            <div className="menu-area__link__element">
              <i className="material-icons menu-area__icon">exit_to_app</i>
              <span>{t('log_out')}</span>
            </div>
          </a>
        </ul>
      </div>
    );
  }
}

Menu.propTypes = {
  t: PropTypes.func.isRequired,
  newConversationsCount: PropTypes.number,
  signOut: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  return {
    dealerId: get(state, ['userData', 'id']),
    newConversationsCount: get(state, ['conversations', 'newConversationsCount']),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    toggleMenu: () => dispatch(TOGGLE_MENU()),
    signOut: () => dispatch(SIGN_OUT()),
  };
};

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps),
  withScopedTranslations('header')
)(Menu);
